module.exports = __webpack_public_path__ + "assets/removingFillers.1eaac78a.svg";